module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Logotipo-Blanco.309ba5b4.svg";